'use client'

import { SessionProvider } from 'next-auth/react'
import { ThemeProvider } from 'next-themes'
import type { ReactNode } from 'react'

import LoadingProgress from '@components/ui/loading-progress'
import Toast from '@components/ui/toast'
import { Providers as TrpcProviders } from '@lib/trpc'

const Providers = ({ children }: { children: ReactNode }) => (
  <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
    <SessionProvider>
      <TrpcProviders>
        <LoadingProgress>
          {children}
          <Toast />
        </LoadingProgress>
      </TrpcProviders>
    </SessionProvider>
  </ThemeProvider>
)

export default Providers
